import React from 'react';
import { Col, Container, Form, FormGroup, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocale } from '@dietlabs/components';

class SystemOfMeasurementsFormPlaceholder extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: null,
    };

    render() {
        return (
            <Container className={this.props.className}>
                <Row>
                    <Col xs="12" md={{ size: 8, offset: 2 }}>
                        <Form>
                            <FormGroup>
                                <Label>
                                    {this.props.t('settings/metric-system')}
                                </Label>
                                <div className="form-check">
                                    <Label className="form-check-label">
                                        <div className="checkmark radio placeholder" />
                                        {this.props.t('settings/si')}
                                    </Label>
                                </div>

                                <div className="form-check">
                                    <Label className="form-check-label">
                                        <div className="checkmark radio placeholder" />
                                        {this.props.t('settings/imperial')}
                                    </Label>
                                </div>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withLocale(SystemOfMeasurementsFormPlaceholder);
